module.exports = __webpack_public_path__ + "d80b84dcfe47a5a832ce9d47cd66c4c1.jpg";